import FieldManagerPanel from './FieldManagerPanel.vue';

export default FieldManagerPanel;
